import React, { useEffect, useState, useRef } from 'react';
import emailjs from "@emailjs/browser";
import './ContactForm.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Alert } from 'react-bootstrap';

function ContactForm() {

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertVariant, setAlertVariant] = useState("success");

  const form = useRef();

  const validateForm = () => {
    const formElements = form.current.elements;
    let isValid = true;

    for (let element of formElements) {
      if (element.required && !element.value) {
        isValid = false;
        alert(`Le champ ${element.name} est requis.`);
        break;
      }
    }

    return isValid;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    if (!validateForm()) {
      setIsButtonDisabled(false);
      return;
    }
    
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_MAIL,
        process.env.REACT_APP_TEMPLATE_MAIL,
        form.current,
        { publicKey: process.env.REACT_APP_PUBLIC_KEY_MAIL }
      )
      .then(
        () => {
          setAlertMessage("Votre message a bien été envoyé !");
          setAlertVariant("success");
          form.current.reset();
        },
        (error) => {
          setAlertMessage("L'envoi du message a échoué. Veuillez réessayer plus tard.");
          setAlertVariant("danger");
        }
      )
      .finally(() => {
        setIsButtonDisabled(false);
      });
  };

  return (
    <>
      {alertMessage && <Alert variant={alertVariant} onClose={() => setAlertMessage(null)} dismissible>{alertMessage}</Alert>}
      <form ref={form} onSubmit={sendEmail} className="join-us-form">
        <div className="form-group">
          <label htmlFor="name">Nom  <span style={{ color: 'red' }}>*</span></label>
          <input type="text" id="name" name="name" placeholder="Entrez votre nom complet" required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email  <span style={{ color: 'red' }}>*</span></label>
          <input type="email" id="email" name="email" placeholder="Entrez votre adresse email" required />
        </div>
        <div className="form-group">
          <label htmlFor="telephone">Téléphone </label>
          <input type="tel" id="telephone" name="telephone" placeholder="Entrez votre numéro de téléphone" />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message <span style={{ color: 'red' }}>*</span></label>
          <textarea
            id="message" name="message" rows="4" placeholder="Votre message" required />
        </div>
        <button id="validateBtn" type="submit" disabled={isButtonDisabled}>
          Envoyer
        </button>
      </form>
    </>
  );
}

export default ContactForm;